export default __webpack_public_path__ + "static/media/message.a4145e87.svg";